import {
    ColoursObj,
    getContrastYIQ,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { DisclosureGroup } from '../../../common/DisclosureGroup'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { getMobileOperatingSystem, isWebPreview } from '../../../utils'
import { logEvent } from '../../firebase/firebase'
import { useGuestStore } from '../guest.store'

export const GuestBanner = () => {
    const { IDtoken } = useBoundStore(
        useShallow((s) => {
            return { IDtoken: s.IDtoken }
        })
    )

    const isGuestMode = useGuestStore((s) => s.isGuestMode)
    if (!isGuestMode) return null
    const button =
        IDtoken === undefined ? (
            !isWebPreview ? (
                <MainButton
                    id="signUpButton"
                    onClick={() => {
                        logEvent('guest_clone_itin', {
                            code: useGuestStore.getState().guestCode,
                        })
                        useGuestStore.getState().setCloneOnSignUp(true)
                        window.pushPath('/authentication/signUp')
                    }}
                >
                    {i18n.t('guest.signUp')}
                </MainButton>
            ) : (
                <MainButton
                    id="downloadButton"
                    onClick={() => {
                        const platform = getMobileOperatingSystem()
                        logEvent('guest_download_app', {
                            code: useGuestStore.getState().guestCode,
                        })
                        if (platform === 'Android') {
                            window.open(
                                'https://play.google.com/store/apps/details?id=com.softpauer.eventr',
                                '_blank'
                            )
                        } else if (platform === 'iOS') {
                            window.open(
                                'https://apps.apple.com/gb/app/eventr-team/id6466819926',
                                '_blank'
                            )
                        } else {
                            window.open(
                                'https://play.google.com/store/apps/details?id=com.softpauer.eventr',
                                '_blank'
                            )
                        }
                    }}
                >
                    {i18n.t('guest.downloadEventR')}
                </MainButton>
            )
        ) : (
            <Stack spacing={'16px'}>
                <MainButton
                    id="duplicateButton"
                    onClick={() => {
                        logEvent('guest_dup_teamselect', {
                            code: useGuestStore.getState().guestCode,
                        })
                        window.pushPath('/guestdup/teamselect')
                    }}
                >
                    {i18n.t('guest.duplicateItinerary')}
                </MainButton>
                <MainButton
                    id="returnToTeamButton"
                    variant="secondary"
                    onClick={() => {
                        logEvent('guest_returnToTeam', {
                            code: useGuestStore.getState().guestCode,
                        })
                        window.pushPath('account/changeOrg')
                    }}
                >
                    {i18n.t('guest.returnToTeam')}
                </MainButton>
            </Stack>
        )
    return (
        <DisclosureGroup
            childrenHandlePadding
            containerStyle={{
                backgroundColor: ColoursObj.coreLights.primary,
                padding: '0px 8px',
            }}
            title="Guest view"
            isOpen={true}
            content={
                <Stack padding={'0px 8px 16px 8px'} spacing={'8px'}>
                    <Typography
                        variant="bodySubtext"
                        color={getContrastYIQ(ColoursObj.coreLights.primary)}
                    >
                        {IDtoken === undefined
                            ? isWebPreview
                                ? i18n.t('guest.duplicateToDoMore')
                                : i18n.t('guest.signUpToDuplicate')
                            : i18n.t('guest.duplicateToDoMore')}
                    </Typography>
                    {button}
                </Stack>
            }
        />
    )
}
